import { ChartJsConfigHelper } from './../../../../helpers';
import { ConfigService } from './../../../../services/config.service';
import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import * as Chart from 'chart.js';
import { ProcessGrade } from '../../../../models/reporting';

@Component({
    selector: 'app-respondents-by-grade-module',
    templateUrl: './respondents-by-grade-module.component.html',
    styles: []
})
export class RespondentsByGradeModuleComponent implements OnInit, AfterViewInit {
    @Input() processGrades: Array<ProcessGrade>;

    canvas: any;
    ctx: any;
    pieWidth: number;

    private colors = [];
    constructor(private readonly configService: ConfigService) { }

    ngOnInit() {
        const canvasArea = document.getElementsByClassName('overall-rating-bar');
        this.pieWidth = canvasArea[0].clientWidth;
        this.colors = this.configService.configData.pieColors;
    }

    ngAfterViewInit() {
        this.canvas = document.getElementById('gradesPie');
        
        this.ctx = this.canvas.getContext('2d');
        const datasets: Array<Chart.ChartDataSets> = [Object.assign({},
            {
                data: this.processGrades.map(x => x.value), fill: false,
                backgroundColor: this.processGrades.map((x, i) => this.colors[i]), borderWidth: 0
            })];
        const labels = this.processGrades.map(x => x.gradeName);
        const respondentsByGradeChart = new ChartJsConfigHelper('pieGradeChart');
        window['pieGradeChart'] = new Chart(this.ctx, respondentsByGradeChart.getPieChartJsOptions(labels, datasets));
    }
}
